import { Injectable } from '@angular/core';
import { StateDispatcher, StateOrchestrator } from 'microedge-rxstate/dist';
import { GridStateAction } from './grid-state-action.type';


export class GridStateDispatcher extends StateDispatcher<GridStateAction> {
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

export class GridStateOrchestrator<T> extends StateOrchestrator<T, GridStateAction> {
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
